module.exports = __webpack_public_path__ + "assets/img/icon_service14.42bf68b5.png";